import { useNavigate } from 'react-router';
import { Card, CardContent, CardHeader, CardTitle } from "src/@/components/ui/card";
import { Button } from "src/@/components/ui/button";
import { Separator } from "src/@/components/ui/separator";
import Iconify from 'src/components/Iconify';
import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';
import { verifyRules } from 'src/utils/functions';
import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";

export default function ModulosConfig({ 
  user
}) {
  const navigate = useNavigate();
  const [selectedModule, setSelectedModule] = useState(null);
  
  const [list, setList] = useState([
    // {
    //   name: 'Analise de Atendimento',
    //   path: '/dashboard/configuracoes/analise-atendimento',
    //   icon: 'mdi:robot-happy-outline',
    //   color: 'bg-violet-500',
    //   description: 'Sistema de análise automática de atendimentos que utiliza IA para avaliar a qualidade e eficiência das interações com clientes.',
    //   features: [
    //     'Análise de sentimento em tempo real',
    //     'Identificação de palavras-chave',
    //     'Sugestões de melhorias',
    //     'Relatórios detalhados'
    //   ]
    // },
    {
      name:'Autocompletar',
      path: '/dashboard/configuracoes/autocompletar',
      icon: 'mdi:brain',
      color: 'bg-violet-600',
      description: 'Sistema de autocompletar inteligente que sugere respostas e ações com base no contexto da conversa.',
      features: [
        'Sugestões contextuais',
        'Aprendizado contínuo',
        'Personalização por usuário',
        'Integração com histórico'
      ]
    },
    {
      name:'Transcrição de voz',
      path: '/dashboard/configuracoes/transcricao-voz',
      icon: 'ri:voice-ai-fill',
      color: 'bg-violet-600',
      description: 'Transcreva audios enviados pelo cliente e transforme em texto.',
      features: [
        'Transcrição de voz para texto',
        'Reconhecimento de fala',
        'Personalização por usuário',
        'Integração com histórico'
      ]
    }
  ]);

  return (
    <div className="container mx-auto p-4">
      <HeaderPageComponentConfig
        titulo="Módulos"
        descricao="Gerencie funções de IA"
      />

      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
        {list && list.map((item, index) => (
          <ModuloCard
            key={index}
            user={user}
            onDelete={() => {}}
            onConfig={() => {
              navigate({
                pathname: item.path
              })
            }}
            onInfo={() => setSelectedModule(item)}
            canal={item}
          />
        ))}
      </div>

      <Dialog open={!!selectedModule} onOpenChange={() => setSelectedModule(null)}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <div className={`p-2 rounded-full ${selectedModule?.color} bg-opacity-20`}>
                <Iconify 
                  icon={selectedModule?.icon} 
                  width={24} 
                  height={24} 
                  className={selectedModule?.color.replace('bg', 'text')} 
                />
              </div>
              {selectedModule?.name}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              {selectedModule?.description}
            </p>
            <div>
              <h4 className="text-sm font-medium mb-2">Funcionalidades:</h4>
              <ul className="space-y-2">
                {selectedModule?.features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-2 text-sm text-gray-600">
                    <Iconify icon="mdi:check-circle" width={16} height={16} className="text-green-500" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

function ModuloCard({ user, canal, botao, onConfig, onInfo, fbLogin, onDelete }) {
  return (
    <Card className="transition-all duration-300 bg-gradient-to-b from-white to-slate-100 bg-opacity-50">
      <CardContent className="p-4">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex flex-col items-center gap-1">
            <div className={`p-2 rounded-full ${canal.color} bg-opacity-20`}>
              <Iconify 
                icon={canal.icon} 
                width={24} 
                height={24} 
                className={canal.color.replace('bg', 'text')} 
              />
            </div>
            <div className="flex items-center gap-1">
              <h5 className="text-sm font-medium text-gray-800">
                {canal.name}
              </h5>
              <Button
                variant="ghost"
                size="icon"
                className="h-4 w-4 p-0 hover:bg-transparent"
                onClick={onInfo}
              >
                <Iconify 
                  icon="mdi:information-outline" 
                  width={14} 
                  height={14} 
                  className="text-gray-500"
                />
              </Button>
            </div>
          </div>

          <div className="w-full">
            {verifyRules(user.rules, "editar_canal") && (
              <div className="flex justify-center">
                <Button
                  onClick={onConfig}
                  size="sm"
                  className={`w-full ${canal.color} hover:${canal.color.replace('bg', 'bg')} hover:bg-opacity-90 text-xs`}
                >
                  <Iconify 
                    icon="mdi:cog-outline" 
                    width={14} 
                    height={14} 
                    className="mr-1" 
                  />
                  Configurar
                </Button>
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}


